export class Config {
  [name: string]: any;
}
